import ToBooleanText from '../../components/utilities/Table/helperKIvaTable';
import AmountGeneralRequest from '../../components/utilities/Table/generalColumns/AmountGeneralRequest';
import { RequestWarranty } from '../../components/utilities/Table/generalColumns/RequestWarranty';

const commonColumnsCartera = [
    {
        Header: 'Nro crédito',
        accessor: 'num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'numero_identificacion_cliente',
    },
    // {
    //     Header: 'Garantía vehicular',
    //     accessor: 'id',
    // },
    {
        Header: 'Cliente',
        accessor: 'nombre_cliente',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Producto',
        accessor: 'linea_credito',
    },
    // {
    //     Header: 'Oficina',
    //     accessor: 'oficina.label',
    // },
    {
        Header: 'Días mora',
        accessor: 'dias_mora',
    },
    AmountGeneralRequest({
        id: 'saldo',
        Header: 'Saldo total',
        accessor: 'saldo_prestamo',
    }),
];

const commonColumns = [
    RequestWarranty,
    ToBooleanText('tramite', 'Tramite voluntario', 'tramite_voluntario'),
    {
        Header: 'Fecha creación',
        accessor: 'gestiongmv.fecha_creacion',
    },
    {
        Header: 'Nro crédito',
        accessor: 'credito.num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'solicitud.persona.numero_identificacion',
    },

    {
        Header: 'Cliente',
        accessor: 'solicitud.persona.full_name',
        typeId: 'HeaderClient',
    },

    {
        Header: 'Producto',
        accessor: 'credito.subproducto.label',
    },

    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
    // {
    //     Header: 'SubEstado',
    //     accessor: 'subestado.label',
    // },
];

const requestsWarrantyList = [
    {
        id: 'desembolsadas_gerente_operacion',
        label: 'CARTERA',
        offices: true,
        subproducto: true,
        columns: commonColumnsCartera,
        registrationLimit: 5,
        buttonAction: [{ name: 'radication' }],
        // buttonAction: [{ name: 'takeRequestWarranty' }],
        apiSolicitud: true,
    },
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '1',
        offices: true,
        responsable: true,
        columns: commonColumns,
        registrationLimit: 5,
        apiSolicitud: false,
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        status: '2',
        responsable: false,
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        apiSolicitud: false,
        nameColumnProcessed: [
            {
                name: 'usuario_creacion_gestion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
    },
];
export default requestsWarrantyList;
